import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

// import styles
import './selectshop.scss'

// Actions
import { loginAs } from '../../actions/auth'

// Elements
import Col from '../../shared/elements/col'
import Panel from '../../shared/elements/panel'
import Button from '../../shared/elements/button'

// Utils
import { translation } from '../../utils/helpers'

class SelectShop extends PureComponent {

  constructor (props) {
    super(props)
    this.state = {

    }
    this.renderShop = this.renderShop.bind(this)
  }
  componentWillReceiveProps (nextProps) {
    // console.log('componentWillReceiveProps', nextProps.auth)
    // if (!isEqual(this.props.auth.user, nextProps.auth.user)) {
    setTimeout(() => {
      if (nextProps.auth.user.UserType === 7) { // shopowners
        this.props.router.replace('/orders')
      } else {
        this.props.router.replace('/workscreen')
      }
    }, 150)
    // }
  }
  renderShop (shop, key) {
    const selectShop = (e) => {
      e.preventDefault()
      this.props.loginAs(0, shop.ShopId).then((res) => {
        // window.localStorage.setItem('workscreen_view', null)
        // setTimeout(() => {
        //   this.props.router.replace('/workscreen')
        // }, 250)
      }, () => {
        window.toastr.error(translation('1892'), translation('216'))
      })
    }
    return (
      <Button key={key} onClick={selectShop} labelText={shop.ShopName} style='link' />
    )
  }

  render () {
    return (
      <div className='selectshop__screen'>
        <Col>
          <Panel title={translation('1896')}>
            {this.props.companies.map(this.renderShop)}
          </Panel>
        </Col>
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    companies: state.common.companies
  }
}

export default connect(mapStateToProps, {
  loginAs
})(SelectShop)



// WEBPACK FOOTER //
// ./src/app/pages/SelectShop/index.js